<template>
  <div style="padding-bottom: 20px">
      <div class="backList" v-show="isShowReportListBtn">
        <van-icon name="wap-home" size="25" color="#fff" @click="GoBackHome()" />
      </div>
    <van-sticky @scroll="getStauts">
      <div class="one">
        <div class="function" :class="{ sticky: sticky }">
          <div class="personal_im">
            <!-- <van-nav-bar title="" left-arrow @click-left="goBack" /> -->

            <div class="name">{{ reportInfo.PatientName }}</div>
            <div class="gender">{{ reportInfo.PatientSex }}</div>
            <div class="age">{{ reportInfo.PatientAge }}</div>
          </div>
          <div class="study">{{ reportInfo.StudyTypeName }}诊断</div>
        </div>
      </div>
    </van-sticky>
    <div class="conter_bj ceiling">
      <h2>
        检查号：<span>{{ reportInfo.ExaminationID }}</span>
      </h2>
      <h2>
        影像号：<span>{{ reportInfo.PatientID }}</span>
      </h2>
      <h2 v-if="reportInfo.OutpatientNO">
        门诊号：<span>{{ reportInfo.OutpatientNO }}</span>
      </h2>
      <h2 v-if="reportInfo.HospitalizationNO">
        住院号：<span>{{ reportInfo.HospitalizationNO }}</span>
      </h2>
      <!-- <div
        class="yinyang"
        :class="
          reportInfo.YinYangAttributeName === '阴性'
            ? 'isYin'
            : reportInfo.YinYangAttributeName && reportInfo.YinYangAttributeName.length > 0
            ? 'isYang'
            : ''
        "
      >
        {{ reportInfo.YinYangAttributeName }}
      </div> -->
      <div v-show="reportInfo.YinYangAttributeName&&reportInfo.YinYangAttributeName.length>0" class="yinyangx_box" :style="{color:yinyangColor,borderColor: yinyangColor}">
          <div class="yinyangx_inner_ring">
            <div>{{ reportInfo.YinYangAttributeName }}</div>
            <div>
              <van-icon name="star" size="20px" :color="yinyangColor"/>
            </div>
          </div>
      </div>
    </div>
    <div class="conter_tb">
      <div class="function_con" @click="handlePdfReview()" v-if="reportInfo.ReportRelaFileFullName">
        <div class="function_icon">
          <img src="../../assets/report_film.png" />
        </div>
        <h4>原始报告</h4>
      </div>
      <div class="function_con" @click="ImageClick(1)" v-if="IsShowFilmImageBtn">
        <div class="function_icon">
          <img src="../../assets/report_film.png" />
        </div>
        <h4>电子胶片</h4>
      </div>
      <div class="function_con" v-if="IsShowDicImageBtn" @click="ImageClick(2)">
        <div class="function_icon">
          <img src="../../assets/report_image.png" />
        </div>
        <h4>影像浏览</h4>
      </div>
      <div class="function_con" v-if="IsShowImageViewBtn" @click="handleImageReview()">
        <div class="function_icon">
          <img src="../../assets/report_film.png" />
        </div>
        <h4>视频</h4>
      </div>
      <div v-if="isShowShareImage" class="function_con function_icon_share" @click="handleShowShare()">
        <div class="function_icon">
          <img src="../../assets/blueshare.png" />
        </div>
        <h4>分享</h4>
      </div>
    </div>
    <div class="conter_bj">
      <div class="check_information">检查信息</div>
      <div class="study_type">
        <p>{{ reportInfo.StudyTypeName }}</p>
        <p>{{ reportInfo.StudyPartName }}</p>
      </div>
      <h2>
        申请医生：<span>{{ reportInfo.ApplyDoctorName }}</span>
      </h2>
      <h2>
        登记时间：<span>{{ this.FormatDate(reportInfo.ApplyDate) }}</span>
      </h2>
      <h2>
        检查时间：<span>{{ this.FormatDate(reportInfo.CheckDate) }}</span>
      </h2>
      <h2>
        检查项目：<span>{{ reportInfo.StudyItemName }}</span>
      </h2>
    </div>
    <div class="conter_bj">
      <div class="check_information">报告信息</div>
      <div style="display: inline-block; position: absolute; right: 20px; top: 10px">
        <van-button
          type="primary"
          size="mini"
          color="linear-gradient(to right, rgb(185 182 255), rgb(64 165 255))"
          :disabled="isZoomOut"
          @click="fontReduction"
          >A
          <span style="vertical-align: super">-</span>
        </van-button>

        <van-button
          type="primary"
          size="mini"
          color="linear-gradient(to right, rgb(185 182 255), rgb(64 165 255))"
          :disabled="isZoom"
          @click="fontEnlargement"
          >A
          <span style="vertical-align: super">+</span>
        </van-button>
      </div>
      <div :style="{ fontSize: fontSize + 'px', letterSpacing: letterSpacing + 'px' }">
        <h2>
          诊断医生：<span>{{ reportInfo.DiagnosisDoctorName }}</span>
        </h2>
        <h2>
          诊断时间：<span>{{ this.FormatDate(reportInfo.DiagnosisDate) }}</span>
        </h2>
        <h2 v-if="reportInfo.SysType === 1 || reportInfo.SysType === 4">
          审核医生：<span>{{ reportInfo.VerifierDoctorName }}</span>
        </h2>
        <h2 v-if="reportInfo.SysType === 1 || reportInfo.SysType === 4">
          审核时间：<span>{{ this.FormatDate(reportInfo.VerifyDate) }}</span>
        </h2>
        <h2>影像所见：</h2>
        <h2>
          <i>{{ reportInfo.ScreenageDescription }}</i>
        </h2>
        <h2>诊断意见：</h2>
        <h2 class="diagnosis">
          <i>{{ reportInfo.ScreenageSuggestion }}</i>
        </h2>
      </div>
    </div>
    <div class="conter_bj" v-if="ImageInfos.length > 0 || ReportImageInfos.length > 0">
      <van-row>
        <van-col v-if="ReportImageInfos && ReportImageInfos.length > 0">
          <div class="check_information">报告图片</div>
          <div style="display: flex; overflow-x: auto; padding: 3px; overflow-y: hidden">
            <img
              :src="ReportImageInfos[0].src"
              style="width: 100px; height: 100px; border-radius: 10px"
              @click="handerReportImagePreview()"
            />
          </div>
        </van-col>
        <van-col span="12" v-if="ImageInfos && ImageInfos.length > 0">
          <div class="check_information">检查图片</div>
          <div style="display: flex; overflow-x: auto">
            <img
              :src="ImageInfos[0]"
              style="margin: 2px; width: 100px; height: 100px; border-radius: 10px"
              @click="handerImagePreview()"
            />
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="instructions">*说明：此报告仅供临床参考，不做诊断依据</div>
    <div>
      <van-overlay :show="showPay" class="dialog-demo">
        <div class="wrapper">
          <div class="block">
            <div style="display: flex; justify-content: flex-end">
              <van-icon
                name="close"
                size="25"
                color="gray"
                @click="
                  () => {
                    showPay = false
                    IsAgreeAgreement = false
                  }
                "
                style="margin: 5px"
              />
            </div>
            <p class="select-server">选择服务类型</p>
            <div class="line"></div>
            <div
              class="select-day"
              v-for="item in StrategyInfos"
              :key="item.ID"
              :class="{ select: (SelectedStrategyInfo ? SelectedStrategyInfo.ID : '') === item.ID }"
              @click="StrategyInfoClick(item)"
            >
              <p class="pay-money">{{ item.Price }}元</p>
              <p class="pay-day">
                {{ item.Price == 0 ? '限当日免费查看' : '云影像保存' }}
                {{ item.StorageDuration }}
                {{ item.StorageDurationUnit == 0 ? '天' : item.StorageDurationUnit == 1 ? '月' : '年' }}
              </p>
              <span :class="item.Price == 0 ? 'payMark' : 'payMarks'">{{ item.Price == 0 ? '免费试用' : '' }}</span>
              <span
                :class="(RecommendStrategyInfo ? RecommendStrategyInfo.ID : '') == item.ID ? 'payMark' : 'payMarks'"
                >{{ (RecommendStrategyInfo ? RecommendStrategyInfo.ID : '') == item.ID ? '推荐' : '' }}</span
              >
            </div>
            <div class="save-line"></div>
            <div style="padding-left: 1rem; margin-top: 15px">
              <van-checkbox
                v-model="IsAgreeAgreement"
                checked-color="#3398FF"
                :label-disabled="true"
                shape="square"
                icon-size="15px"
              >
                <span style="font-size: 0.86rem; color: #9f9d9d; position: absolute; margin-top: -0.6rem">
                  我已阅读并同意<a @click="openUserAgreement">《云影像用户须知》</a>
                </span>
              </van-checkbox>
            </div>
            <van-button type="info" class="goPay" @click="UserPay">{{ PayBtnTitle }}</van-button>
          </div>
        </div>
      </van-overlay>
    </div>
    <!-- //使用 -->
    <!-- index	自定义页码内容	{ index: 当前图片的索引 }
             cover	自定义覆盖在图片预览上方的内容 -->
    <van-image-preview v-model="imagePreviewShow" :images="images" closeable @change="onChange">
      <!-- <template v-slot:index>第{{ index }}页</template> -->
      <template v-slot:cover>{{ imgContent[index] }}</template>
    </van-image-preview>
    <ShareView ref="shareDialog" :isShowShare="IsShowShare" @EncryptionValueChanged="EncryptionValueChanged" />
    <van-loading type="spinner" class="loading" v-show="loadingSohw" />
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import ShareView from './ShareView'
import { DecryptAES, EncryptAES, decryptDes } from '../../utils/stringUtils'
import {
  GetCloudImageReportInfoByID,
  GetPatientReportImageInfos,
  GetCloudImagePaymentPermissionInfo,
  AddCloudImagePaymentOrderInfo,
  GetCloudImageConfigInfoByReportID
} from '@/api/CloudFilmService'
import * as cacheUtils from '../../utils/cacheUtils'
import Vue from 'vue'
import enums from '@/utils/enums'
// import DragIcon from '@/components/DragIcon/index'
Vue.use(ImagePreview)
import * as cacheManage from '../../utils/cacheUtils'

export default {
  name: 'reportView',
  components: {
    ShareView,
    // DragIcon,
  },
  data() {
    return {
      reportInfo: {},
      ReportImageInfos: [],
      VideoList: [],
      DicomList: [],
      FilmFileList: [],
      ImageInfos: [],
      isShowShareImage: true,
      IsShowShare: false,
      IsShowDicImageBtn: false,
      IsShowFilmImageBtn: false,
      isShowReportListBtn: false,
      IsShowImageViewBtn: false,
      IsEncryption: false,
      isZoomOut: true,
      isZoom: false,
      fontSize: 16,
      sticky: false,
      letterSpacing: 0,
      loadingSohw: true,
      showPay: false, //显示支付
      StrategyInfos: [],
      SelectedStrategyInfo: null,
      RecommendStrategyInfo: null, //推荐使用的商品
      PayBtnTitle: '去支付', //支付按钮名称  去支付或者免费体验
      IsAgreeAgreement: false, //是否同意支付协议  默认不同意
      UserClickImageType: 0, //用户点击的影像类型  0未知  1胶片   2原始影像
      imagePreviewShow: false,
      index: 0,
      imgContent: [],
      images: [],
      yinyangColor:'rgb(135, 203, 180)',
      CloudImagePACSType:enums.CloudImagePACSTypes.ELPACS.value,
      WPACSPrePath:''
    }
  },
  watch: {
    fontSize(newVal) {
      if (newVal > 16 && newVal < 22) {
        this.isZoomOut = false
        this.isZoom = false
      }
      if (newVal < 17) {
        this.isZoomOut = true
      }
      if (newVal > 21) {
        this.isZoom = true
      }
    },
  },
  // activated() {
  //   this.getDate()
  // },

  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      if (cacheManage.GetIsLogin()) {
        if (from.name == 'UserAgreement') {
          console.log(1)
          } else {
            vm.getDate()
          }
        } else {
          vm.$router.replace('/login?'+window.location.href.split('?')[1])
        }
      
    })
  },

  methods: {
    getDate() {
      this.loadingSohw = true
      cacheUtils.SetGoBackUrlParms(window.location.href.split('?')[1])
      this.isShowReportListBtn = cacheUtils.GetIsShowReportListBtn()
      var reportID = this.$route.query.id
      this.IsEncryption = DecryptAES(this.$route.query.isEncryption) === '1'
      this.isShowShareImage = DecryptAES(this.$route.query.isShare) != '1'
      cacheUtils.SetIsShowShareBtn(this.isShowShareImage)
      //分享过来的
      GetCloudImageReportInfoByID({ ID: reportID })
        .then(async (resp) => {
          if (resp.Success) {
            //密名分享
            if (this.IsEncryption) {
              resp.Result.PatientName = '***'
            }
            resp.Result.PatientSex = enums.SexsEnum.getNameByValue(resp.Result.PatientSex)
            this.reportInfo = resp.Result
            if (this.reportInfo.YinYangAttributeName === '阴性') {
              this.yinyangColor = 'rgb(128, 203, 180)'
            } else {
              this.yinyangColor = 'rgb(247, 24, 3)'
            }
            const fileServiceUrl = await cacheUtils.GetFileServiceUrl()
            //加载报告的图片
            this.GetReportImages(this.reportInfo.ReportImageRelaFileName, fileServiceUrl)
            this.IsShowFilmImageBtn = this.reportInfo.SysType === 1 || this.reportInfo.SysType === 4
            this.IsShowDicImageBtn = this.reportInfo.SysType === 1 || this.reportInfo.SysType === 4
            this.IsShowImageViewBtn = false // resp.SysType === 2 || resp.SysType === 3 暂时取消视频功能
            //加载影像文件数据
            setTimeout(() => {
              this.loadingSohw = false
            }, 1000)
          } else {
            this.loadingSohw = false
          }
        })
        .catch(() => {
          this.loadingSohw = false
        })
    },
    GoBackHome() {
      this.$router.push({ path: '/ReportListView' })
    },
    // 图片预览事件
    onChange(index) {
      this.index = index
    },
    //获取报告的图片
    GetReportImages(reportImageRelaFileName, fileServiceUrl) {
      this.ReportImageInfos = []
      if (reportImageRelaFileName) {
        var imageStr = reportImageRelaFileName.split('|')
        if (imageStr && imageStr.length > 0) {
          imageStr.forEach((element) => {
            var imageInfo = {}
            if (element.indexOf('&') > -1) {
              imageInfo.src = fileServiceUrl + element.substring(0, element.indexOf('&'))
              imageInfo.describe = element.substring(element.indexOf('&') + 1, element.length)
            } else {
              imageInfo.src = fileServiceUrl + element
              imageInfo.describe = ''
            }
            this.ReportImageInfos.push(imageInfo)
          })
        }
      }
    },
    // 加载影像文件数据
    GetDicomImages(patientReportID) {
      GetPatientReportImageInfos({ patientReportID: patientReportID }).then(async (resp) => {
        if (resp.Success && resp.Result && resp.Result.length > 0) {
          const fileServiceUrl = await cacheUtils.GetFileServiceUrl()
          //检查的图片
          var imageData = resp.Result.find((c) => c.Category === 3)
          if (imageData && imageData.Images && imageData.Images.length > 0) {
            this.ImageInfos = imageData.Images.map((c) => fileServiceUrl + c.ImageRelaFileName)
            //     imageData.Images.forEach(element => {
            //     var imageInfo = {}
            //     if (element.indexOf('&') > -1) {
            //         imageInfo.src = fileServiceUrl + element.ImageRelaFileName.substring(0, element.indexOf("&"))
            //         imageInfo.describe = element.ImageRelaFileName.substring(element.indexOf('&') + 1, element.length)
            //     } else {
            //         imageInfo.src = fileServiceUrl + element
            //         imageInfo.describe = ''
            //     }
            //     this.ImageInfos.push(imageInfo)
            // });
          }
          //检查的视频
          this.VideoList = resp.Result.find((c) => c.Category === 4)
          this.DicomList = resp.Result.find((c) => c.Category === 2)
          this.FilmFileList = resp.Result.find((c) => c.Category === 1)
        }
      })
    },
    //查看报告图片
    handerReportImagePreview() {
      // ImagePreview({
      //     images: this.ReportImageInfos.map(item => item.src),
      //     closeable: true,
      // });
      this.imagePreviewShow = true
      this.images = this.ReportImageInfos.map((item) => item.src)
      this.imgContent = this.ReportImageInfos.map((item) => item.describe)
    },
    //查看检查图片
    handerImagePreview() {
      // ImagePreview({
      //     images: this.ImageInfos,
      //     closeable: true,
      // });
      this.imagePreviewShow = true
      this.images = this.ImageInfos
      // this.images = this.ImageInfos.map(item => item.src)
      // this.imgContent = this.ReportImageInfos.map(item => item.describe)
    },
    //PDF预览
    handlePdfReview() {
      if (this.reportInfo.ReportRelaFileFullName) {
        this.$router.push({ path: '/ReportPdfView', query: { path: this.reportInfo.ReportRelaFileFullName,a:123 } })
      } else {
        this.$notify({ type: 'danger', message: '没有查询到检查的报告文件！' })
        
      }
    },
    //胶片单击
    ImageClick(type) {
      this.UserClickImageType = type
      // console.log('this.reportInfo', this.reportInfo)
      GetCloudImagePaymentPermissionInfo({
        hospitalID: this.reportInfo.HospitalID,
        cloudImageReportID: this.reportInfo.ID,
      }).then((res) => {
        var IsDirectVisit = true
        if (res.Success) {
          if (res.Result.IsEnablePay) {
            //是否启用支付
            if (res.Result.IsExpired) {
              //是否过期
              IsDirectVisit = false
              this.StrategyInfos = res.Result.StrategyInfos
              //默认选中价格最高的  并且推荐使用
              var maxPrice = Math.max.apply(
                Math,
                res.Result.StrategyInfos.map(function (item) {
                  return item.Price
                })
              )
              var infos = res.Result.StrategyInfos.filter((item) => item.Price == maxPrice)
              if (infos) {
                this.SelectedStrategyInfo = infos[0]
                this.RecommendStrategyInfo = infos[0]
              }
              //打开商品列表
              this.showPay = true
              return
            }
          }
        }
        if (IsDirectVisit) {
          if (this.UserClickImageType == 1) {
            this.FilmReview()
          }
          if (this.UserClickImageType == 2) {
            this.DcmImageReview()
          }
        }
      })
    },
    FilmReview() {
      this.$router.push({
        path: '/filmImageView',
        query: {
          reportInfoID: this.reportInfo.ID,
          isEncryption: this.$route.query.isEncryption,
          CloudImagePatientID: EncryptAES(this.reportInfo.CloudImagePatientID),
        },
      })

      //胶片预览
      // GetPatientReportImageInfos({ patientReportID: this.reportInfo.ID }).then((resp) => {
      //   if (resp.Success && resp.Result && resp.Result.length > 0) {
      //     this.FilmFileList = resp.Result.find((c) => c.Category === 1)
      //     if (this.FilmFileList && this.FilmFileList.Images && this.FilmFileList.Images.length > 0) {

      //       AddCloudImageViewRecord({
      //         CloudImagePatientID: this.reportInfo.CloudImagePatientID,
      //         IDs: this.FilmFileList.ExaminationImageIDs,
      //       }).then()
      //     } else {
      //       this.$notify({ type: 'danger', message: '没有查询到检查的胶片文件！' })
      //     }
      //   } else {
      //     this.$notify({ type: 'danger', message: '没有查询到检查的胶片文件！' })
      //   }
      // })
    },
    DcmImageReview() {
      GetCloudImageConfigInfoByReportID({ReportID:this.$route.query.id}).then(resp=>{
        if(resp.Success){
          if(resp.Result.CloudImagePACSType===enums.CloudImagePACSTypes.ELPACS.value){
            this.$router.push({
              path: '/dicomView',
              query: { reportInfoID: this.reportInfo.ID, isEncryption: this.$route.query.isEncryption },
            })
          }else{
            this.$router.push({
              path: '/thirdDicomView',
              query: { ExaminationID: EncryptAES(this.reportInfo.ExaminationID), PatientID: EncryptAES(this.reportInfo.PatientID),WebPacsURL:EncryptAES(resp.Result.WPACSPrePath) },
            })
          }
        }
      })
      

      // //原始影像预览
      // GetPatientReportImageInfos({ patientReportID: this.reportInfo.ID }).then((resp) => {
      //   if (resp.Success && resp.Result && resp.Result.length > 0) {
      //     this.DicomList = resp.Result.find((c) => c.Category === 2)
      //     if (this.DicomList && this.DicomList.Images && this.DicomList.Images.length > 0) {

      //       AddCloudImageViewRecord({
      //         CloudImagePatientID: this.reportInfo.CloudImagePatientID,
      //         IDs: this.DicomList.ExaminationImageIDs,
      //       }).then()
      //     } else {
      //       this.$notify({ type: 'danger', message: '没有查询到检查的影像文件！' })
      //     }
      //   } else {
      //     this.$notify({ type: 'danger', message: '没有查询到检查的影像文件！' })
      //   }
      // })
    },
    //查看超声/内镜图像
    handleImageReview() {
      GetPatientReportImageInfos({ patientReportID: this.reportInfo.ID }).then((resp) => {
        if (resp.Success && resp.Result && resp.Result.length > 0) {
          this.VideoList = resp.Result.find((c) => c.Category === 4)
          if (this.VideoList && this.VideoList.Images && this.VideoList.Images.length > 0) {
            this.$router.push({
              path: '/imageVideoView',
              query: { reportInfoID: this.reportInfo.ID, isEncryption: this.$route.query.isEncryption },
            })
          } else {
            this.$notify({ type: 'danger', message: '没有查询到检查的视频文件！' })
          }
        } else {
          this.$notify({ type: 'danger', message: '没有查询到检查的视频文件！' })
        }
      })
    },
    openUserAgreement() {
      //打开用户须知
      this.$router.push('/userAgreement')
      // this.$refs.UserAgreement.UserAgreement()
    },
    UserPay() {
      //支付
      if (this.SelectedStrategyInfo) {
        if (this.IsAgreeAgreement) {
          if (this.SelectedStrategyInfo.Price == 0) {
            //免费体验//0免费  1微信  2支付宝  3其它
            AddCloudImagePaymentOrderInfo({
              info: {
                CloudImagePaymentStrategyID: this.SelectedStrategyInfo.ID,
                CloudImageReportID: this.reportInfo.ID,
                PaymentTime: this.moment().format('YYYY-MM-DD HH:mm:ss'),
                PaymentWay: enums.PaymentWay.免费.value,
              },
            }).then((resp) => {
              if (resp.Success) {
                this.showPay = false
                if (this.UserClickImageType == 1) {
                  this.FilmReview()
                }
                if (this.UserClickImageType == 2) {
                  this.DcmImageReview()
                }
              }
            })
          } else {
            localStorage.removeItem('OutTradeNo')
            localStorage.setItem('PayGoBackUrl',EncryptAES(window.location.href.split('?')[1]))
            //付费
            let ua=navigator.userAgent.toLowerCase()
            var IsWxBrowser= /micromessenger/.test(ua)?true:false
            if(IsWxBrowser){
              var info= {
                  OutTradeNo:this.moment().format('YYYY-MM-DD HH:mm:ss'),
                  CloudImagePatientID: this.reportInfo.CloudImagePatientID,
                  CloudImagePaymentStrategyID: this.SelectedStrategyInfo.ID,
                  CloudImageReportID: this.reportInfo.ID,
                  PaymentWay: enums.PaymentWay.微信.value,
                }
              AddCloudImagePaymentOrderInfo(info).then((resp)=>{
                if (resp.Success) {
                  var PayInfo={lastOrderNumber:resp.Result,StrategyInfo:this.SelectedStrategyInfo}
                  cacheManage.SetWXJsApiPayInfo(EncryptAES(JSON.stringify(PayInfo)))
                  this.$router.push({ name: 'PayInfo'})
                }
              })

              Object.assign(this.SelectedStrategyInfo, { CloudImageReportID: this.reportInfo.ID })
              
            }else{
              Object.assign(this.SelectedStrategyInfo, { CloudImageReportID: this.reportInfo.ID })
              this.$router.push({ name: 'PayInfo', params: { key: JSON.stringify(this.SelectedStrategyInfo) ,ID:this.reportInfo.ID,PatientID:this.reportInfo.CloudImagePatientID} })
            }
          }
        } else {
          this.$notify({ type: 'warning', message: '请阅读并同意《云影像用户须知》！' })
        }
      } else {
        this.$notify({ type: 'warning', message: '请选择需要购买的服务信息！' })
      }
    },
    StrategyInfoClick(item) {
      //点击选择商品
      this.SelectedStrategyInfo = item
      if (this.SelectedStrategyInfo && this.SelectedStrategyInfo.Price == 0) {
        this.PayBtnTitle = '免费体验'
      } else {
        this.PayBtnTitle = '去支付'
      }
    },
    //分享
    handleShowShare() {
      this.$refs.shareDialog.SecurityCode = decryptDes(this.reportInfo.SecurityCode)
      this.$refs.shareDialog.ReportID = this.reportInfo.ID
      this.$refs.shareDialog.showShare = true
    },
    // //报告列表
    // handleReportList() {
    //     this.$router.push('/ReportListView')
    // },
    //是否密名分享值变化  更新报告显示的姓名 否则截图时会看到姓名
    EncryptionValueChanged(value) {
      this.IsEncryption = value
    },
    //日期格式化
    FormatDate(value) {
      if (this.moment(value).format('YYYY-MM-DD') === '1900-01-01') {
        return ''
      } else {
        return this.moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    fontReduction() {
      if (this.fontSize > 16) {
        this.fontSize--
        if (this.letterSpacing != 0) {
          this.letterSpacing--
        }
      } else {
        console.log(this.fontSize)
        this.isZoom = false
      }
    },
    fontEnlargement() {
      if (this.fontSize < 22) {
        this.fontSize++
        if (this.fontSize > 20) {
          this.letterSpacing++
        }
      } else {
        return
      }
    },
    getStauts(e) {
      if (e.isFixed) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    },
  },
}
</script>
<style scoped>
@charset "utf-8";
::v-deep .van-button--mini{
  width: 24px;
  padding: 0;
}
.one {
  /* width: 92%; */
  /* margin: 0px 4% 0; */
  border-radius: 7px 7px 0 0;
  background: #fff;
  position: relative;
  background-image: url(../../assets/main_top.png);
  background-size: 100% 90%;
  background-repeat: no-repeat;
  z-index: 1;
}

.conter_tb {
  /* width: 92%; */
  margin: 0px 0 10px;
  background: #fff;
  padding: 0 15px;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: space-evenly;
}

.conter_bj {
  /* width: 92%; */
  margin: 0 0 15px;
  border-radius: 10px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  background: #fff;
  padding: 12px 15px;
  position: relative;
}

.ceiling {
  border-radius: 0 0 10px 10px;
}

.personal_im {
  color: white;
  height: 40px;
  display: flex;
}

.personal_im div {
  font-size: 18px;
  margin-right: 20px;
  line-height: 28px;
}

/* .personal_im div:nth-child(1){
  margin-right: 15px;
  line-height: 34px;
}  */
.study {
  font-size: 20px;
  color: white;
}


.isYin {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}

.isYang {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: #fff;
}

.conter_bj h2 {
  color: #888;
  line-height: 28px;
}

.conter_bj h2 span {
  color: #111;
}

.conter_bj h2 i {
  color: #111;
  display: block;
  word-wrap: break-word;
}

.function {
  text-align: center;
  padding: 5px 15px 8px;
  display: flex;
  justify-content: space-between;
}

.function_con .function_icon {
  width: 50px;
  height: 50px;
  border: 1px solid #aab7d4;
  border-radius: 50%;
  padding: 12px;
}

.function_con h4 {
  color: #40a5ff;
  line-height: 22px;
  font-size: 13px;
  text-align: center;
}

.check_information {
  height: 30px;
  font-size: 17px;
  line-height: 30px;
  color: #40a5ff;
  font-weight: 900;
  position: relative;
}

.check_information:before {
  display: block;
  content: '';
  position: absolute;
  left: -8px;
  top: 5px;
  width: 3px;
  height: 17px;
  border-radius: 2px;
  background-color: #40a5ff;
}

.instructions {
  width: 100%;
  height: 38px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  padding-left: 20px;
  font-size: 13px;
  line-height: 30px;
  color: #f00;
  position: fixed;
  left: 0;
  bottom: 0;
  background: white;
}

.conter_bj:nth-child(3) .van-button--mini + .van-button--mini {
  margin-left: 10px;
}

.diagnosis {
  margin-bottom: 8px;
}

.sticky {
  height: 55px;
  margin: 0 -20px;
  background-color: #fff;
  padding: 8px 30px 0;
  background-image: url(../../assets/main_top.png);
  background-size: 100% 90%;
  background-repeat: no-repeat;
  box-shadow: 1px 2px 3px #ddd;
}

.conter_bj /deep/.van-sticky {
  text-align: right;
}

.select {
  position: relative;
  width: 90%;
  height: 74px;
  text-align: center;
  line-height: 93px;
  color: #40a5ff;
  background-color: #fff;
  box-shadow: 0px 2px 7px 0px rgba(85, 110, 97, 0.35);
  border: 1px solid rgba(64, 165, 255, 1);
}

.select:before {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  border: 17px solid #40a5ff;
  border-top-color: transparent;
  border-left-color: transparent;
}

.select:after {
  content: '';
  width: 5px;
  height: 12px;
  position: absolute;
  right: 6px;
  bottom: 6px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
  transform: rotate(45deg);
}

.save-line {
  width: 100%;
  height: 0px;
  border-bottom: solid #dcdcdc 1px;
  margin-top: 10px;
}

.select-server {
  vertical-align: bottom;
  text-align: left;
  margin-left: 20px;
  padding: 2px;
  height: 40px;
  line-height: 40px;
  margin-top: -30px;
}

.line {
  width: 90%;
  height: 1px;
  border-top: solid #40a5ff 1px;
  margin-left: 5%;
}

.select-day {
  width: 90%;
  margin-left: 5%;
  border-radius: 10px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  padding: 12px 15px;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}

.select-day p {
  height: 50px;
  line-height: 50px;
}

.payMark {
  position: absolute;
  top: 0;
  left: 0px;
  font-size: 12px;
  line-height: 20px;
  display: inline-block;
  text-align: center;
  background: #f74c31;
  color: #fff;
  height: 18px;
  line-height: 16px;
  border-radius: 8px 0;
  padding: 0 4px;
  background-clip: padding-box;
  vertical-align: middle;
}

.payMarks {
  display: none;
}

.goPay {
  width: 100%;
  height: 44px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  background-color: #40a5ff;
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  margin-top: 12px;
}

.van-overlay {
  z-index: 100;
}

.study_type {
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  margin: 5px 0 7px;

}
.study_type p:nth-child(1){
  margin-right: 10px;
white-space: nowrap;
}
.study_type p {
  border: 1px solid #aab7d4;
  padding: 0px 4px;
  line-height: 26px;
  /* height: 28px; */
  border-radius: 4px;
  color: #40a5ff;
  box-shadow: 0 0 7px rgba(186, 195, 209, 0.5);

}
.backList {
  width: 35px;
  height: 35px;
  background: #57aeee;
  position: absolute;
  top: 15px;
  right: 15px;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>

<style lang="less" scoped>
.wrapper {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 300px;
  height: auto;
  border-radius: 10px;
  background-color: #fff;
}

// 图片预览样式
/deep/.van-image-preview__cover {
  height: 40px;
  color: white;
  bottom: 0;
  top: initial;
  right: 0;
  text-align: center;
  line-height: 40px;
}
.yinyangx_box{
  width: 60px;
  height: 60px;
  border: 3px solid ;
  font-weight: 600;
  border-radius: 50%;
  padding: 3px;
  transform: rotate(-45deg); 
  -o-transform: rotate(-45deg); 
  -webkit-transform: rotate(-45deg); 
  -moz-transform: rotate(-45deg); 
  position: absolute;
  bottom: 15px;
  right: 25px;
}

.yinyang {
  color: white;
  border-radius: 15px;
  font-size: 12px;
  height: 30px;
  padding: 0 10px;
  line-height: 30px;
  white-space: nowrap;
}
.yinyangx_inner_ring {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid ;
  padding-top: 6px;
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
</style>
